import {
  ItemByStudentsType,
  TotalsFinancesByStudentsType,
} from 'app/dataTypes/reports/data/common/financesSummary'

import { sortClasses, sortDirectionWith } from 'app/common/lib/sort'
import { groupBy, pipe, values, prop } from 'ramda'
import toFixedValue from 'app/common/lib/toFixedValue'

import { ApiItemByStudents, ApiTotals } from './financesSummary'

const sortByClasses = sortClasses<{ studentKlass: string }>('down', prop('studentKlass'))
const sortByName = sortDirectionWith<{ studentName: string }>('down', prop('studentName'))

const sortedByClassThenName = (arr: Array<ItemByStudentsType>): Array<ItemByStudentsType> =>
  pipe(
    groupBy<ItemByStudentsType>(prop('studentKlass')), // Группируем по классу
    values, // Получаем массив групп
    sortByClasses, // Сортируем группы по классу
    (arr) => arr.map((group) => sortByName(group)), // Сортируем внутри групп по имени
    (arr) => arr.flat(),
  )(arr)

export const convertByStudents = (
  rows: Array<ApiItemByStudents>,
  nullValueForFinalDate: boolean = false,
): Array<ItemByStudentsType> => {
  const res = rows.map(
    ({
      student_name: studentName,
      student_klass: studentKlass,
      balance_before: balanceBefore,
      balance_before_exists: balanceBeforeExists,
      balance_after: balanceAfter,
      balance_after_exists: balanceAfterExists,
      payments,
      payments_negative: paymentsNegative,
      correction_payments: correctionPayments,
      correction_payments_negative: correctionPaymentsNegative,
      write_offs: writeOffs,
      payments_result: paymentsResult,
      correction_payments_result: correctionPaymentsResult,
    }): ItemByStudentsType => ({
      studentName,
      studentKlass,
      balanceBefore: toFixedValue(balanceBefore),
      balanceBeforeExists,
      balanceAfter: nullValueForFinalDate && balanceAfter === 0 ? null : toFixedValue(balanceAfter),
      balanceAfterExists,
      payments: toFixedValue(payments),
      paymentsNegative: toFixedValue(paymentsNegative),
      correctionPayments: toFixedValue(correctionPayments),
      correctionPaymentsNegative: toFixedValue(correctionPaymentsNegative),
      writeOffs: toFixedValue(writeOffs),
      paymentsResult: toFixedValue(paymentsResult),
      correctionPaymentsResult: toFixedValue(correctionPaymentsResult),
    }),
  )

  return sortedByClassThenName(res)
}

export const convertTotals = (
  totals: ApiTotals,
  nullValueForFinalDate: boolean = false,
): TotalsFinancesByStudentsType => {
  const {
    payments,
    corrections,
    write_offs: writeOffs,
    balance_after: balanceAfter,
    balance_before: balanceBefore,
  } = totals
  return {
    payments: toFixedValue(payments),
    corrections: toFixedValue(corrections),
    writeOffs: toFixedValue(writeOffs),
    balanceAfter: nullValueForFinalDate && balanceAfter === 0 ? null : toFixedValue(balanceAfter),
    balanceBefore: toFixedValue(balanceBefore),
  }
}
